/**
 * État d'une animation pour l'admin : valide ? défauts de qualité (mise en
 * page mesurée, rythme) ? voix enregistrées ? Calculé sur place avec le
 * validateur du paquet (même code que le serveur), pas avec le rapport
 * stocké : un brouillon généré avant une mise à jour du contrôle est revu
 * avec les règles du jour.
 */

import {
  isQualityWarning,
  validateJraf,
  type JrafIssue,
  type JrafDocument,
} from '@jeraisonne/animation';

export interface AnimationHealth {
  valid: boolean;
  errors: JrafIssue[];
  /** défauts que l'élève verrait (mise en page, rythme) */
  quality: JrafIssue[];
  /** autres conseils */
  advice: JrafIssue[];
  doc: JrafDocument | null;
  scenes: number;
  /** scènes dont la voix est enregistrée (exigé pour la vidéo publiée) */
  recorded: number;
}

export type AnimationReadiness = 'ready' | 'fix' | 'invalid';

export function animationHealth(
  draft: unknown,
  opts: { toolIds?: readonly string[] } = {},
): AnimationHealth | null {
  if (draft == null) return null;
  const r = validateJraf(draft, opts.toolIds ? { toolIds: opts.toolIds } : {});
  const quality = r.warnings.filter(isQualityWarning);
  const advice = r.warnings.filter((w) => !isQualityWarning(w));
  const scenes = r.ok ? r.doc.scenes : [];
  return {
    valid: r.ok,
    errors: r.ok ? [] : r.errors,
    quality,
    advice,
    doc: r.ok ? r.doc : null,
    scenes: scenes.length,
    recorded: scenes.filter((s) => Boolean(s.narration.audioAssetId)).length,
  };
}

/** Prête à publier (valide, sans défaut), à reprendre (défauts), ou invalide. */
export function readinessOf(h: AnimationHealth | null): AnimationReadiness {
  if (!h || !h.valid) return 'invalid';
  return h.quality.length > 0 ? 'fix' : 'ready';
}
